import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { Store } from 'store';
import getPreventFromProceedFlag from '../selector/getPreventFromProceedFlag';
import { setPreventFromProceedAction } from '../slice';

const setPreventFromProceedOperation =
  (flag: boolean) => (dispatch: ThunkDispatch<Store, undefined, AnyAction>, getState: () => Store) => {
    const store = getState();
    const currentFlag = getPreventFromProceedFlag(store);

    if (currentFlag !== flag) {
      dispatch(setPreventFromProceedAction(flag));
    }
  };

export default setPreventFromProceedOperation;
